export var TextPresetKeys;
(function (TextPresetKeys) {
    TextPresetKeys["BodyXS"] = "Body-XS";
    TextPresetKeys["Title"] = "Title";
    TextPresetKeys["Menu"] = "Menu";
    TextPresetKeys["HeadingXL"] = "Heading-XL";
    TextPresetKeys["PageTitle"] = "Page-title";
    TextPresetKeys["BodyS"] = "Body-S";
    TextPresetKeys["HeadingL"] = "Heading-L";
    TextPresetKeys["BodyL"] = "Body-L";
    TextPresetKeys["HeadingM"] = "Heading-M";
    TextPresetKeys["HeadingS"] = "Heading-S";
    TextPresetKeys["BodyM"] = "Body-M";
})(TextPresetKeys || (TextPresetKeys = {}));
export var ChatIcons;
(function (ChatIcons) {
    ChatIcons["SquareTransparent"] = "square-transparent";
    ChatIcons["SquareFilled"] = "square-filled";
    ChatIcons["CircleTransparent"] = "circle-transparent";
    ChatIcons["CircleFilled"] = "circle-filled";
    ChatIcons["CircleLegacy"] = "circle-legacy";
    ChatIcons["Close"] = "close";
    ChatIcons["LegacySmiley"] = "legacy-smiley";
    ChatIcons["LegacyNoGender"] = "legacy-no-gender";
    ChatIcons["LegacyFemale"] = "legacy-female";
    ChatIcons["LegacyMale"] = "legacy-male";
})(ChatIcons || (ChatIcons = {}));
export var MinimizedChatLayouts;
(function (MinimizedChatLayouts) {
    MinimizedChatLayouts["Icon"] = "icon";
    MinimizedChatLayouts["Floating"] = "floating";
    MinimizedChatLayouts["Fixed"] = "fixed";
})(MinimizedChatLayouts || (MinimizedChatLayouts = {}));
export var ChatThumbnailType;
(function (ChatThumbnailType) {
    ChatThumbnailType["Icon"] = "icon";
    ChatThumbnailType["LegacyIcon"] = "legacy-icon";
    ChatThumbnailType["URL"] = "URL";
})(ChatThumbnailType || (ChatThumbnailType = {}));
//# sourceMappingURL=chat-settings.js.map